var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('the-header'),_vm._v(" "),_c('the-progress-bar',{attrs:{"steps":_vm.completedSteps}}),_vm._v(" "),_c('div',{staticClass:"main-app"},[_c('div',{staticClass:"shell"},[_c('transition',{attrs:{"name":"no-mode-translate-fade","mode":"out-in"}},[_c('router-view')],1)],1)])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a70d218","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 425
// module chunks = 0